import { HeaderNavbarBrand } from './view';
export default HeaderNavbarBrand;
